/** /lti/launched#access=…&refresh=…&to=… (STORY-092): the integrations service lands a
 * platform user here with a fresh session in the URL fragment (never sent to a server). */
import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { keepTokens } from "../auth/session";

export function LtiLaunched() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const frag = new URLSearchParams(location.hash.replace(/^#/, ""));
    const access = frag.get("access");
    if (!access) { setFailed(true); return; }
    keepTokens(access, frag.get("refresh") || null, true);
    history.replaceState(null, "", location.pathname);
    const to = frag.get("to") || "/t";
    // Both branches stay under the mount prefix: a `to` that is not a path falls back to
    // the app's own root, never the origin's (which may be another application's).
    const base = import.meta.env.BASE_URL.replace(/\/$/, "");
    window.location.replace(to.startsWith("/") ? `${base}${to}` : `${base}/`);
  }, [navigate]);
  return (
    <main className="mx-auto max-w-md p-6 text-center">
      <p role="status">{failed ? t("lti.failed") : t("lti.landing")}</p>
    </main>
  );
}
